<template>
  <div>
    <div class="mt-5 mb-2 d-flex">
      <h1 class="ang-heading">Formularz hipoteczny</h1>
    </div>
    <div>
      <div>
        <h3 class="ang-heading mt-5" id="clientFormHeader" v-if="false">
          <span v-if="step === 1">Twoje podstawowe dane</span>
          <span v-if="step === 2">Zatrudnienie</span>
          <span v-if="step === 3">Zobowiązania</span>
          <span v-if="step === 4 && survey_type === 1">Cel kredytowania</span>
          <span v-if="step === 5 && survey_type === 1">Nieruchomości kredytowane i zabezpieczenia</span>
          <span v-if="step === 6">Dokumenty</span>
        </h3>
        <div class="ang-card ang-card--visible">
          <div class="d-flex  mt-3 mb-2" v-if="false && step !== 0">
            <span class="ml-auto mr-3" v-if="survey_type === 1">Postęp wypełniania formularza {{Math.round(parseFloat((step-1) * 100/5))}}%</span>
            <span class="ml-auto mr-3" v-else>Postęp wypełniania formularza {{Math.round(parseFloat((step-1) * 100/3))}}%</span>
          </div>
          <div class="progress ml-3 mr-3" style="height: 15px;" v-if="false && step !== 0">
            <div class="progress-bar" v-if="survey_type === 1" role="progressbar" :style="'width: ' + (step-1) * 100/5 + '%;'" :aria-valuenow="(step-1) * 100/5" aria-valuemin="0" aria-valuemax="100"></div>
            <div class="progress-bar" v-else role="progressbar" :style="'width: ' + (step-1) * 100/3 + '%;'" :aria-valuenow="(step-1) * 100/3" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
          <div class="steps" v-if="step !== 0">
            <ul id="progressbar">
              <li :class="getClasses(1)" @click="changeStep(1)">Dane osobowe</li>
              <li :class="getClasses(2)" @click="changeStep(2)">Dochody</li>
              <li :class="getClasses(3)" @click="changeStep(3)">Zobowiązania</li>
              <li :class="getClasses(4)" @click="changeStep(4)">Cel kredytu</li>
              <li :class="getClasses(5)" @click="changeStep(5)">Nieruchomości i zabezpieczenia</li>
              <li :class="getClasses(6)" @click="changeStep(6)">Dokumenty</li>
            </ul>
          </div>
          <personal-form :base_client="client" :base="base" v-if="step === 1" @forward="nextStep" :code="code"></personal-form>
          <employment-form :base_client="client" :base="base" v-if="step === 2" @forward="nextStep" @backward="step--" :code="code"></employment-form>
          <obligations-form :base_client="client" :base="base" v-if="step === 3" @forward="nextStep" @backward="step--" :code="code"></obligations-form>
          <credit-form :base_client="client" :base="base" v-if="step === 4 && survey_type === 1" @forward="nextStep" @backward="step--" :code="code"></credit-form>
          <property-form :base_client="client" :base="base" v-if="step === 5 && survey_type === 1" @forward="nextStep" @backward="step--" :code="code"></property-form>
          <bucket :base_client="client" :base="base" v-if="step === 6" @forward="nextStep" @backward="step--" :code="code"></bucket>
          <div class="p-4" v-if="survey_type === 1 && step === 7">
            <div class="alert alert-success ang-alert-success mt-3">
              <h5 class="ang-card-title">Dziękujemy za wypełnienie formularza</h5>
              <div>
                <p>Twój Ekspert ANG zajmie się przygotowaniem wniosku do banku.</p>
                <p>W razie dodatkowych pytań zwróć się do swojego eksperta lub napisz wiadomość na adres: klient@grupaang.pl</p>
              </div>
            </div>
            <div class="d-flex">
              <div>
                <button class="btn ang-button _bg_color3 mt-1" @click.stop.prevent="step--">Wstecz</button>
              </div>
            </div>
          </div>
          <div class="p-4" v-if="step === 0">
            <div class="row" >
              <div class="col-12 d-flex">
                <div class="ang-card-title mt-3">Dzień dobry!</div>
              </div>
            </div>
            <p>Dziękujemy za zainteresowanie usługami oferowanymi przez Grupę ANG S.A. (dawniej ANG Spółdzielnia).</p>
            <p>Znajdujesz się na pierwszym kroku naszego formularza hipotecznego. Na kolejnych stronach poprosimy Cię o podanie Twoich danych osobowych, informacji dotyczących Twojej sytuacji finansowej oraz innych danych niezbędnych do przygotowania dla Ciebie oferty kredytowej. Dzięki wypełnieniu formularza Twój Ekspert ANG będzie mógł dużo szybciej przygotować wniosek do banku.</p>
            <p>Twoje dane są bezpieczne i zostaną usunięte z naszej bazy niezwłocznie po zamknięciu procesu hipotecznego.</p>
            <p>W razie dodatkowych pytań zwróć się do swojego eksperta lub napisz wiadomość na adres: klient@grupaang.pl</p>
            <div class="text-right mt-4">
              <button class="btn btn-lg  ang-button ang-btn-lg" @click.stop.prevent="step = 1">Zaczynamy!</button>
            </div>
          </div>
        </div>
        <div class="deco-2">
          <div class="parallax-scene">
            <svg width="291" height="301" class="parallax-move" data-depth="0.4"
                 xmlns="http://www.w3.org/2000/svg" viewBox="0 0 290.8 301.08">
              <path d="M181.24 268.83c-31.74-6.2-50.08 15.86-62.26 7.02-11.8-8.57 3.2-30.91-9.95-48.42-12.47-16.6-33.28-6.33-53.6-20.08-27.6-18.68-39.29-71.48-20.51-94.07 24.06-28.93 89.26 2.43 106.9-26.45 9.81-16.07-6.37-32.26 3.89-45.48 17.77-22.9 93.16-8.8 102.43 21.79 7.87 26-38.3 43.14-34.86 82.29 3.09 35.18 42.11 41.11 41.82 75.45-.23 27.1-24.82 55.31-46.76 56.6-10.66.64-11.66-5.63-27.1-8.65z"
                    fill="#60c3b4"></path>
            </svg>
          </div>
        </div>
        <div class="deco-4">
          <div class="parallax-scene">
            <svg class="parallax-move" data-depth="0.4" height="226.12" viewBox="0 0 222.922 226.12"
                 width="222.922" xmlns="http://www.w3.org/2000/svg">
              <path d="M152.318 155.231c-8.283 6.18-21.242 2.146-37.635-3.187-25.472-8.286-23.941-14.048-35.653-14.508-20.199-.793-26.436 16.274-46.978 13.665-2.8-.356-15.594-1.979-20.159-10.578-7.85-14.792 11.33-45.223 36.242-55.391 12.282-5.014 23.97-4.294 44.123-3.05 27.015 1.667 35.371 7.761 46.188 1.495 13.407-7.766 9.779-22.462 20.207-26.726 19.37-7.923 60.748 30.97 54.278 48.263-5.292 14.117-39.544 5.884-51.77 28.451-5.162 9.53-2.022 16.48-8.843 21.566z"
                    fill="#11A68A"></path>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import personalForm from '@/components/partials/forms/details/personalForm'
import employmentForm from '@/components/partials/forms/details/employmentForm'
import obligationsForm from '@/components/partials/forms/details/obligationsForm'
import creditParamsForm from '@/components/partials/forms/details/creditParamsForm'
import propertyForm from '@/components/partials/forms/details/propertyForm'
import bucket from '@/components/partials/forms/details/bucket'
export default {
  data () {
    return {
      step: 0
    }
  },
  props: ['client', 'base', 'survey_type', 'code'],
  components: {
    'personal-form': personalForm,
    'employment-form': employmentForm,
    'obligations-form': obligationsForm,
    'credit-form': creditParamsForm,
    'property-form': propertyForm,
    bucket
  },
  name: 'ClientMainForm',
  computed: {
    client_step () {
      let client_step = 0

      if (this.client.data.step_1 === '1') {
        client_step = 1
      }
      if (this.client.data.step_2 === '1') {
        client_step = 2
      }
      if (this.client.data.step_3 === '1') {
        client_step = 3
      }
      if (this.client.data.step_4 === '1') {
        client_step = 4
      }
      if (this.client.data.step_5 === '1') {
        client_step = 5
      }
      if (this.client.data.step_6 === '1') {
        client_step = 6
      }
      return client_step
    }
  },
  methods: {
    getClasses (step) {
      let classes = ''

      if (this.step === step) {
        classes += 'active'
      } else if (this.client_step < step-1) {
        classes += 'disabled'
      }

      return classes
    },
    changeStep (step) {
      if (step < this.step || step-1 <= this.client_step) {
        this.step = step
      }
    },
    nextStep () {
      this.$emit('fetchClient')
      if (this.survey_type === 1) {
        this.step++
      } else {
        if (this.step === 3) {
          this.step = 6
        } else {
          this.step++
        }
      }
      this.$forceUpdate()
    }
  }
}
</script>

